import React from 'react'
import PropTypes from 'prop-types'

import WarningIcon from '@components/Icon/Warning'
import InfoBox from '@components/InfoBox'

const InfoMessage = ({ message, margin }) => (
  <div className={`expert-form__input-group ${margin || ''}`}>
    <label className='expert-form__label' />
    <div className='expert-form__value-wrapper'>
      <InfoBox theme='yellow' icon={<WarningIcon />}>
        {message}
      </InfoBox>
    </div>
  </div>
)

InfoMessage.propTypes = {
  message: PropTypes.string,
  margin: PropTypes.string
}

export default InfoMessage
